import Headroom from 'headroom.js';

let _ = require('lodash');

const mainMenu = document.getElementById('block-hoofdnavigatie');
const menuToggle = document.getElementById('menu-toggle');

let subMenus = {};

if (!_.isNil(mainMenu)) {
    subMenus = mainMenu.getElementsByClassName('menu-item--expanded');
}

// Header
const header = document.getElementById('page-header');

let headroom;

if (!_.isNil(header)) {

    // Header height
    let headerHeight = header.clientHeight;

    header.style.setProperty('--header-height', headerHeight + 'px');

    // Headroom
    let headroomOptions = {
        offset: headerHeight,

        onUnpin: function () {
            let searchBarRegion = document.querySelector('.region-search-bar');

            if (_.isNil(searchBarRegion)) {
                return;
            }

            searchBarRegion.classList.remove('open');
        }
    }

    headroom = new Headroom(header.querySelector('.region-header'), headroomOptions);

    headroom.init();
}

if (!_.isEmpty(subMenus)) {
    document.onclick = function (e) {
        if (
            !e.target.classList.contains('menu') &&
            !e.target.classList.contains('menu-item--expanded-toggle') &&
            !e.target.classList.contains('region-header') &&
            !e.target.classList.contains('header-inner') &&
            !e.target.classList.contains('close-sub-menu') &&
            !e.target.parentElement.parentElement.classList.contains('custom-menu-item')
        ) {
            closeAllSubmenus();
        }
    }
}

// Menu toggle
if (! _.isNil(menuToggle)) {
    menuToggle.addEventListener('click', function () {
        if (menuToggle.getAttribute('aria-expanded') === 'true') {
            menuToggle.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('main-menu-active')
        } else {
            menuToggle.setAttribute('aria-expanded', 'true');
            document.body.classList.add('main-menu-active')
        }
    });
}

document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('main-menu-active');
    }
});

// Searchbar toggle
if (!_.isNil(document.getElementById('search-bar-toggle'))) {
    document.getElementById('search-bar-toggle').addEventListener('click', (e) => {
        document.querySelector('.region-search-bar').classList.toggle('open');
    });
}

// Footer navigation
const footerMenus = document.querySelectorAll('.region-footer .collapsible-menu');
let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

Array.from(footerMenus).forEach(menu => {
    if (viewportWidth < 768) {
        menu.addEventListener('click', (e) => {
            menu.classList.toggle('open');
        });
    }
});

// Mega menu
let subMenuLevelOneToggle = document.querySelectorAll('button.sub-menu-level-toggle-1');

Array.from(subMenuLevelOneToggle).forEach(toggleLevelOne => {
    let parent = toggleLevelOne.parentElement;
    let closeButton = parent.querySelector('.close-sub-menu');

    toggleLevelOne.addEventListener('click', (e) => {
        if (toggleLevelOne.getAttribute('aria-expanded') !== 'true') {
            closeAllSubmenus();

            headroom.freeze();

            parent.classList.add('open');

            toggleLevelOne.setAttribute('aria-expanded', 'true');

            return;
        }

        headroom.unfreeze();

        parent.classList.remove('open');

        toggleLevelOne.setAttribute('aria-expanded', 'false');
    });

    closeButton.addEventListener('click', (e) => {

        parent.classList.remove('open');

        toggleLevelOne.setAttribute('aria-expanded', 'false');
    });
});


let subMenuLevelTwoToggle = document.querySelectorAll('button.sub-menu-level-toggle-2');

Array.from(subMenuLevelTwoToggle).forEach(toggleLevelTwo => {
    let parent = toggleLevelTwo.parentElement;
    let closeButton = parent.querySelector('.close-sub-menu');

    toggleLevelTwo.addEventListener('click', (e) => {
        if (toggleLevelTwo.getAttribute('aria-expanded') !== 'true') {
            closeAllLevelTwoSubmenus();

            parent.classList.add('open');

            toggleLevelTwo.setAttribute('aria-expanded', 'true');

            return
        }

        parent.classList.remove('open');

        toggleLevelTwo.setAttribute('aria-expanded', 'false');
    });

    closeButton.addEventListener('click', (e) => {

        parent.classList.remove('open');

        toggleLevelTwo.setAttribute('aria-expanded', 'false');
    });
});

function closeAllSubmenus() {
    let menuItems = document.querySelectorAll('nav.menu--main ul.menu li.menu-item--expanded');
    let menuItemExpandedToggles = document.querySelectorAll('nav.menu--main button.menu-item--expanded-toggle');

    Array.from(menuItems).forEach(menuItem => menuItem.classList.remove('open'));
    Array.from(menuItemExpandedToggles).forEach(menuItemExpandedToggle => menuItemExpandedToggle.setAttribute('aria-expanded', 'false'));
}

function closeAllLevelTwoSubmenus() {
    let levelTwoSubMenus = document.querySelectorAll('.sub-menu-level-1 ul.menu > li.menu-item--expanded')

    Array.from(levelTwoSubMenus).forEach(submenu => {
        submenu.classList.remove('open');

        let button = submenu.querySelector('.sub-menu-level-toggle-2');

        button.setAttribute('aria-expanded', 'false');
    });
}